import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";

// НКД на одну бумагу на сегодня. Дата в ISO. Сервер возвращает
// { secid, on_date, accrued_per_bond }.
export function useBondAccrued(secid: string) {
  const today = new Date().toISOString().slice(0, 10);
  return useQuery({
    queryKey: ["bond-accrued", secid, today],
    queryFn: async ({ signal }) => {
      const { data, error } = await api.GET("/api/bond/{secid}/accrued", {
        signal,
        params: { path: { secid }, query: { on_date: today } },
      });
      if (error || !data) throw new Error(String(error ?? "no data"));
      const v = data["accrued_per_bond"];
      return typeof v === "number" ? v : null;
    },
    staleTime: 60 * 60_000,
  });
}
